import loadjs from 'loadjs';

import { log, error as logError } from './log';

const shell = ({
    requestHeaders = {},
    packageManifestEndpoint,
    fetchPackagesOnStart,
    fetchPackagesOnComplete,
    packageNameToUrlResolver,
    onPackageManifestFetchComplete,
    onFetchPackagesOnStartComplete,
    onFetchPackagesOnCompleteHandler
}) => {
    const fetchPackages = (packages, done) => {
        loadjs(packages, {
            success: function success() {
                log('bootstrapped shell success');
                // eslint-disable-next-line no-unused-expressions
                done && done();
            },
            error: function error(depsNotFound) {
                log('bootstrap shell error');
                // eslint-disable-next-line no-unused-expressions
                done && done(depsNotFound);
            },
            async: false
        });
    };

    const initializeAppContainer = () => {
        fetchPackages(fetchPackagesOnStart(), onFetchPackagesOnStartComplete);
        fetchPackages(fetchPackagesOnComplete(), onFetchPackagesOnCompleteHandler);
    };

    fetch(packageManifestEndpoint, { headers: { ...requestHeaders } })
        .then(response => response.json())
        .then(data => {
            window.getPackageConfig = packageNameToUrlResolver;
            onPackageManifestFetchComplete(data);
            initializeAppContainer();
        })
        .catch(err => {
            // eslint-disable-next-line no-unused-expressions
            onFetchPackagesOnCompleteHandler && onFetchPackagesOnCompleteHandler(err);
            logError('Error in fetching package manifest, could not initialize app container:', err);
        });
};

export default shell;
